var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.15 16.275a.72.72 0 0 0 .525.225c.2 0 .383-.083.55-.25a.839.839 0 0 0 .262-.575.674.674 0 0 0-.237-.55L12.825 11.7V7.4a.728.728 0 0 0-.75-.725.728.728 0 0 0-.75.75V12c0 .1.017.192.05.275a.995.995 0 0 0 .15.25l3.625 3.75zM12 22a9.676 9.676 0 0 1-3.875-.788 10.143 10.143 0 0 1-3.188-2.15 10.143 10.143 0 0 1-2.15-3.187A9.676 9.676 0 0 1 2 12c0-1.367.263-2.658.788-3.875a10.143 10.143 0 0 1 2.15-3.188 10.143 10.143 0 0 1 3.187-2.15A9.676 9.676 0 0 1 12 2c1.367 0 2.658.263 3.875.788a10.143 10.143 0 0 1 3.188 2.15c.908.908 1.625 1.97 2.15 3.187A9.676 9.676 0 0 1 22 12a9.676 9.676 0 0 1-.788 3.875 10.143 10.143 0 0 1-2.15 3.188 10.143 10.143 0 0 1-3.187 2.15A9.676 9.676 0 0 1 12 22zm0-1.5c2.333 0 4.333-.833 6-2.5 1.667-1.667 2.5-3.667 2.5-6s-.833-4.333-2.5-6c-1.667-1.667-3.667-2.5-6-2.5S7.667 4.333 6 6c-1.667 1.667-2.5 3.667-2.5 6s.833 4.333 2.5 6c1.667 1.667 3.667 2.5 6 2.5z",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.5887052444a672fc40fc9a7c33c35367.svg";
export { ForwardRef as ReactComponent };